angular.module('aprima-core-ui')
    .directive('apMessageIcon', [function () {
        'use strict';

        function getMessageTypeIconName(messageTypeId, messageSubTypeId) {
            var messageType = 'message';

            messageTypeId = messageTypeId || '';
            messageSubTypeId = messageSubTypeId || '';

            switch (messageTypeId.toUpperCase()) {

                //phone
                case '10101010-0000-0000-0000-000000000003':
                    messageType = 'phone';
                    break;

                //Electronic Rx Errors
                case '10101010-0000-0000-0000-000000000004':
                //Electronic Rx Benefits Errors
                case '10101010-0000-0000-0000-000000000014':
                //Electronic Rx Refill Request
                case 'D7716F70-61D6-4EC0-8BA6-01AFC95E99F2':
                //Rx Refill
                case 'A2B88BC2-E7C8-4990-92F6-AE28B5C0DC77':
                    messageType = 'rx';
                    break;

                //Patient Lab Order
                case '77882A75-7C9D-430B-9DA6-F8ED12058DDB':
                //Service Order Approval
                case '10101010-0000-0000-0000-000000000008':
                    messageType = 'lab';
                    break;
            }

            switch (messageSubTypeId.toUpperCase()) {
                //Task - Lab Alert
                case 'CEC2B936-B5BB-49F7-B4D0-39553FEF64D1':
                    messageType = 'lab';
                    break;

                //Patient Input - Patient Rx Refill Request
                case 'B1B7D286-1FB2-43D0-A883-7946B1CD8751':
                    messageType = 'rx';
                    break;
            }

            return messageType;
        }

        function getMessageTypeId(message) {
            return message.TypeId || message.MessageTypeId ||
                (message.MessageType != null ? message.MessageType.Id : null);
        }

        function getMessageSubTypeId(message) {
            return message.SubTypeId || message.MessageSubTypeId ||
                (message.MessageSubType != null ? message.MessageSubType.Id : null);
        }

        return {
            restrict: 'EA',
            scope: {
                message: '='
            },
            templateUrl: '/core-ui/views/directives/apMessageIcon.html',
            link: function (scope) {
                var typeId = getMessageTypeId(scope.message),
                    subTypeId = getMessageSubTypeId(scope.message),
                    messageType = getMessageTypeIconName(typeId, subTypeId),
                    state = 'incomplete';

                if (scope.message.Urgency && scope.message.Urgency.toLowerCase() === 'urgent') {
                    state = 'urgent';
                } else if (scope.message.Status && scope.message.Status.toLowerCase() === 'complete') {
                    state = 'complete';
                }
                else {
                    state = 'incomplete';
                }

                scope.iconName = messageType + '-' + state;
            }
        };
    }]);
